import React, { useState, useEffect } from "react";
import { Text } from "@semcore/typography";
import Input from "@semcore/ui/input";
import { Box, Flex } from "@semcore/ui/flex-box";
import { useSelector } from "react-redux";
import {
  MAPDELETE_COMPETOTORS,
  PUT_MAPUPDATE_COMPETOTORS,
} from "../../../../../services/constants";
import axios from "axios";
import { Chip } from "@mui/material";
import SemButton from "../../../../../common/components/Button";
import AddProjectStore from "../../../../../store/AddProjectStore";
import AlertPopUp from "../../alert.component";
import { isValidURL } from "../helper";
import { ZustandStore } from "../../../../../store/zustand-store";

const AddCompetitors = () => {
  const { bussiness_name } = ZustandStore((state) => state);
  const {
    addProject,
    setAddProjectField,
    setMultipleFields,
    resetAddProject,
    showNotification,
  } = AddProjectStore((state) => state);

  const [errors, setErrors] = useState({ type: "", message: "", show: false });
  const [CompetitorsName, setCompetitorsName] = useState("");
  const [CompetitorsList, setCompetitorsList] = useState([]);
  const [projectCompetitor, setProjectCompetitor] = useState([]);
  const [Alert, setAlert] = useState({
    type: "",
    message: "",
    show: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [deleteCompetitors, setDeleteCompetitors] = useState([]);

  const total_competitors = CompetitorsList?.length + projectCompetitor?.length;
  const competitorslimit = useSelector((state) => state.competitorslimit);

  // localStorage
  useEffect(() => {
    if (!addProject?.project_id && addProject?.competitors?.length > 0) {
      setCompetitorsList(addProject?.competitors);
    } else if (addProject?.project_id && addProject?.competitors?.length > 0) {
      setProjectCompetitor(addProject?.competitors);
    }
  }, [addProject.competitors]);

  const addCompetitorsHandler = (e) => {
    e.preventDefault();
    const isURL = isValidURL(CompetitorsName);
    const competitor = CompetitorsName;
    const domainPattern = /^[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/i;
    const isDomainValid = domainPattern.test(competitor);

    if (bussiness_name === CompetitorsName) {
      setErrors({
        type: "error",
        message:
          "Your project and competitor domains cannot be the same. Please use a different domain.",
        show: true,
      });
      setCompetitorsName("");
    } else if (isURL || isDomainValid) {
      setErrors({
        type: "error",
        message: "Please enter a valid competitor (Business Name).",
        show: true,
      });
      setCompetitorsName("");
    } else if (projectCompetitor?.includes(CompetitorsName)) {
      setErrors({
        type: "error",
        message: "competitor already added",
        show: true,
      });
      setCompetitorsName("");
    } else if (total_competitors >= competitorslimit) {
      setErrors({
        type: "error",
        message: "your competitor limit is " + competitorslimit,
        show: true,
      });
      setCompetitorsName("");
    } else {
      setErrors({
        type: "",
        message: "",
        show: false,
      });
      setCompetitorsList((obj) => {
        const existObj = obj.find((o, i) => o === CompetitorsName);
        if (existObj) {
          return obj;
        } else {
          return [...obj, CompetitorsName];
        }
      });
      setCompetitorsName("");
    }
  };

  const removeCompetitors = (e) => {
    setCompetitorsList(CompetitorsList.filter((item, index) => index !== e));
  };

  const sendCompetitors = () => {
    setMultipleFields({
      step: 3,
      competitors: CompetitorsList,
      complete_steps: ["1", "2"],
    });
  };

  const handleAddCompetitors = () => {
    const encodedArray = encodeURIComponent(JSON.stringify(CompetitorsList));
    axios
      .put(PUT_MAPUPDATE_COMPETOTORS(addProject?.project_id, encodedArray))
      .then((response) => {
        const data = response?.data?.status;
        if (data === "200") {
          showNotification({
            message: "Competitor added successfully 🎉",
            severity: "success",
          });
          ZustandStore.setState({
            mapshowloader: true,
            map_project: [],
          });
          resetAddProject();
        } else {
          showNotification({
            message: "Unexpected error occurred 🤷‍♂️",
            severity: "error",
          });
        }
      })
      .catch((error) => {
        showNotification({
          message: "Unexpected error occurred 🤷‍♂️",
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDeleteCompetitors = () => {
    const encodedArray = encodeURIComponent(JSON.stringify(deleteCompetitors));

    axios
      .put(MAPDELETE_COMPETOTORS(addProject?.project_id, encodedArray))
      .then((response) => {
        const data = response?.data?.status;
        if (data === "200") {
          showNotification({
            message: "Competitor deleted successfully 🎉",
            severity: "success",
          });
          ZustandStore.setState({
            mapshowloader: true,
            map_project: [],
          });
          resetAddProject();
        } else {
          showNotification({
            message: "Unexpected error occurred 🤷‍♂️",
            severity: "error",
          });
        }
      })
      .catch((error) => {
        showNotification({
          message: "Unexpected error occurred 🤷‍♂️",
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDelayAddCompetitor = () => {
    setTimeout(() => {
      CompetitorsList?.length > 0 && handleAddCompetitors();
    }, 1000);
  };

  const handleSubmitCompetitor = () => {
    setIsLoading(true);
    if (deleteCompetitors?.length > 0 && CompetitorsList?.length > 0) {
      const encodedArray = encodeURIComponent(
        JSON.stringify(deleteCompetitors)
      );

      axios
        .put(MAPDELETE_COMPETOTORS(addProject?.project_id, encodedArray))
        .then((response) => {
          const data = response?.data?.status;
          if (data === "200") {
            setAlert({
              type: "success",
              message: "Competitor deleted successfully",
              show: true,
            });
            handleDelayAddCompetitor();
          } else {
            handleDelayAddCompetitor();
            setAlert({
              type: "error",
              message: "Competitor deletion failed",
              show: true,
            });
          }
        })
        .catch((error) => {
          handleDelayAddCompetitor();
          setAlert({
            type: "error",
            message: "some error occurred",
            show: true,
          });
        });
    } else if (deleteCompetitors?.length > 0) {
      handleDeleteCompetitors();
    } else if (CompetitorsList?.length > 0) {
      handleAddCompetitors();
    }
  };

  const toggleDeleteCompetitor = (domain) => {
    setDeleteCompetitors((prevState) => {
      if (prevState.includes(domain)) {
        // Remove the domain if it's already in the array
        return prevState.filter((item) => item !== domain);
      } else {
        // Add the domain if it's not in the array
        return [...prevState, domain];
      }
    });
  };

  const onChangeCompetitorsName = (e) => {
    const competitor = e;
    const isValid = isValidURL(competitor);
    const domainPattern = /^[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/i;
    const isDomainValid = domainPattern.test(competitor);

    if (e === "") {
      setErrors({
        type: "",
        message: "",
        show: false,
      });
    } else if (isValid || isDomainValid) {
      setErrors({
        type: "error",
        message: "Please enter a valid competitor (Business Name).",
        show: true,
      });
    } else if (projectCompetitor?.includes(competitor)) {
      setErrors({
        type: "success",
        message: "Competitor already added.",
        show: true,
      });
    } else {
      setErrors({
        type: "success",
        message: "Competitor is Valid. Press Enter to add",
        show: true,
      });
    }
    setCompetitorsName(competitor);
  };

  const handleStepChange = (newStep) => {
    setAddProjectField("step", newStep);
  };

  return (
    <>
      <AlertPopUp config={Alert} handleClose={setAlert} />
      <Box style={{ padding: "0 3px" }}>
        <Flex direction="column" mt={2}>
          <Text tag="label" htmlFor="competitor-name" size={200} mb={1}>
            Competitors:
            <span className="ms-1">
              {total_competitors}
              {""}/{""}
              {competitorslimit}
            </span>
          </Text>
          <Input
            size="l"
            state={
              errors.type === "error" && errors.show
                ? "invalid"
                : errors.type === "success" && errors.show
                ? "valid"
                : "normal"
            }
            className="sem-input"
          >
            <Input.Value
              placeholder={
                addProject?.project_id
                  ? "Add Business Name"
                  : "Add Business Name (OPTIONAL)"
              }
              id="competitor-name"
              value={CompetitorsName}
              onChange={(e) => onChangeCompetitorsName(e)}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  addCompetitorsHandler(e);
                }
              }}
            />
          </Input>
          <div className="compe_List mt-2 d-flex align-items-center flex-wrap gap-1">
            {CompetitorsList?.map((competitor, i) => {
              return (
                <Chip
                  key={"CompetitorsList" + i}
                  label={competitor}
                  size="small"
                  className="heading-xs"
                  onDelete={() => removeCompetitors(i)}
                  sx={{
                    height: "20px",
                    backgroundColor: deleteCompetitors?.includes(competitor)
                      ? "#e95655"
                      : "#dcdcdc",
                    "& .MuiChip-label": {
                      fontWeight: "500",
                      fontFamily: "Work Sans",
                      color: `#6C6E79 !important`,
                    },
                  }}
                />
              );
            })}
            {projectCompetitor?.map((competitor, i) => {
              return (
                <Chip
                  key={"projectCompetitor" + i}
                  label={competitor}
                  size="small"
                  className="heading-xs"
                  onDelete={() => toggleDeleteCompetitor(competitor)}
                  sx={{
                    height: "20px",
                    backgroundColor: deleteCompetitors?.includes(competitor)
                      ? "#e95655"
                      : "#dcdcdc",
                    "& .MuiChip-label": {
                      fontWeight: "500",
                      fontFamily: "Work Sans",
                      color: deleteCompetitors?.includes(competitor)
                        ? "#FFFFFF !important"
                        : `#6C6E79 !important`,
                    },
                  }}
                />
              );
            })}
          </div>
          {errors.show && (
            <Text
              color={errors.type === "error" ? "red-500" : "green-500"}
              mt={1}
            >
              {errors.message}
            </Text>
          )}
        </Flex>

        <Flex mt={4} flexWrap gap={3}>
          {addProject?.project_id ? (
            <SemButton
              size="m"
              name="Submit"
              loading={isLoading}
              ml={"auto"}
              disabled={
                (CompetitorsList?.length === 0 &&
                  deleteCompetitors?.length === 0) ||
                isLoading
              }
              onClick={handleSubmitCompetitor}
            />
          ) : (
            <>
              <SemButton
                name="Back"
                size="m"
                onClick={() => handleStepChange(1)}
                ml={"auto"}
              />

              <SemButton size="m" name="Next" onClick={sendCompetitors} />
            </>
          )}
        </Flex>
      </Box>
    </>
  );
};

export default AddCompetitors;
